export default function DeleteAssetTypeConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  assetDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleConfirmDelete = _handleConfirmDelete;

  /** *********************************************
   * Event Handlers
   */

  function _handleCloseDialog($event) {
    _closeDialog($event);
  }

  function _handleConfirmDelete($event) {
    loaderService.showViewLoader = true;
    return assetDataService.deleteAssetType(vm.assetType.customerAssetTypeId)
      .then(() => {
        alerts.success(`The asset type "${vm.assetType.name}" was successfully deleted.`);
        if (vm.updateCallBack) {
          vm.updateCallBack();
        }
        _closeDialog($event);
      }).catch(() => {
        alerts.error('An error occurred while deleting the asset type.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  /** *********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.assetAdmin.deleteAssetTypeConfirmDialog);
  }
}

DeleteAssetTypeConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'assetDataService',
  'loaderService',
  'ssDialogService'
];
